export default __webpack_public_path__ + "static/media/reports.ac846c59.svg";